

























































































































import _ from 'lodash';
import {Component, Mixins, Vue} from "vue-property-decorator";
import QDetailModal from "@/components/qDetailModal.vue";
import Category from "@/model/category";
import Menu from "@/model/menu";
import NumberGenerator from "@/common/mixins/numberGenerator";
import AllYouCanEatDrink from "@/common/mixins/allYouCanDrinkEat";
import { ReloadManager } from "@/common/util/reloadManager";
import OrderComponent from "@/components/order/orderComponent.vue";
import categoryApi from "@/api/categoryApi";
import {namespace} from "vuex-class";
import MenuSet from "@/model/menuSet";
import System from "@/model/system";
import { NO_IMAGE_URL } from "@/common/constant";

const menuStore = namespace("MenuStore")
const optionStore = namespace("OptionStore")
const systemStore = namespace("SystemStore")
const categoryStore = namespace("CategoryStore")
const languageStore = namespace("LanguageStore")

@Component({
  name: "MenuList",
  components: {OrderComponent, QDetailModal},
})
export default class MenuList extends Mixins(NumberGenerator, AllYouCanEatDrink) {
  @menuStore.Getter
  getMenuList!: Menu[];
  @menuStore.Getter
  isShowNotAllYouCanEatMobile!: boolean;
  @optionStore.Getter
  getOptionList!: Menu[];
  @systemStore.Getter
  getSystem!: System;
  @categoryStore.Getter
  getCategories!: Category[];
  @categoryStore.Getter
  getSubCategories!: Category[];
  @languageStore.Getter
  getMenuNameKey: string

  public menuTmp = new Menu();
  public menuScrollList;
  public menuSetList: MenuSet[] = [];
  public aycdFlag = false;
  public menuTop = 0;
  public isOnStatusForCategory = "0";
  public isOnStatusForSubCategory = "0";
  private MARGIN_CSS_DEFAULT = 30;
  public isClickMenu = false;
  public noImageUrl = NO_IMAGE_URL;

  async mounted() {
    ReloadManager.load(this.getSystem).connectSocket(true);
    Vue.prototype.isLoading = false;
    if (this.getMenuList.length === 0) {
      ReloadManager.load(this.getSystem).getItems();
    }
  }

  public get namekey() {
    return this.getMenuNameKey;
  }

  get menuList () {
    return this.getMenuList
  }

  public pageYOffset = 0;

  get categoriesStatusList(): Category[] {
    const categories = this.getCategories;
    const subCats = this.subCategoriesStatusList;

    const activeMenuCategories = _.filter(
      categories,
      (cat: Category) => _
        .map(subCats, sub => sub.superItemCategory)
        .includes(cat.identifier)
    );

    return _.orderBy(activeMenuCategories, (cat: Category) => cat.sortOrder);
  }

  get subCategoriesStatusList(): Category[] {
    const subCategories = this.getSubCategories;
    const menus = this.getMenuList;

    const activeMenuSubCategoryIds = _.uniq(_.map(menus, (menu: Menu) => {
      if (this.isShowNotAllYouCanEatMobile && !menu.allYouCanEat) {
        return;
      }

      return menu.itemCategory;
    }));
    const activeMenuSubCategories = _.filter(
      subCategories,
      (sub: Category) => activeMenuSubCategoryIds.includes(sub.identifier)
    );

    return _.orderBy(activeMenuSubCategories, (cat: Category) => cat.sortOrder);
  }

  get subCategorieAndMenuStatusList(): {category: Category, menus: Menu[]}[] {
    const subCats = this.subCategoriesStatusList;

    return _.map(subCats, (subcat: Category) => {
      const menus = this.menuList.filter(menu => {
        let rtn =  menu.itemCategory === subcat.identifier;
        // @see https://qumitai.backlog.jp/view/HAYAWAZA-227
        if (this.isShowNotAllYouCanEatMobile) {
          rtn = rtn && menu.allYouCanEat;
        }

        return rtn;
      });
      return {
        category: subcat,
        menus: _.sortBy(menus, menu => menu.sortOrder),
      }
    });
  }

  async created() {
    if (!this.$isServer) {
      window.addEventListener('scroll', this._scrollListener)
    }
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this._scrollListener)
  }

  menuListBySubCategory(categoryId) {
    return this.menuList ? this.menuList.filter(menu => menu.itemCategory === categoryId) : null;
  }

  public isOnStatus(index, identifier, isCategory = false): string {
    const isCheckStatus = (isCategory) ? this.isOnStatusForCategory : this.isOnStatusForSubCategory
    if (index.toString() === "0" && isCheckStatus.toString() === "0") {
      return "on"
    } else if (identifier.toString() === isCheckStatus.toString()) {
      return "on"
    }
    return "";
  }

  public async changeMenu(identifier, isCategory = false) {
    const elementList = []
    if (!isCategory) {
      this.isClickMenu = true;

      const elements = this.$refs['menu_' + identifier];

      if (typeof elements === 'object') {
        const itemList = Object.values(elements).map(item => [item])
        itemList.map(value => {
          if (value[0].id.toString().slice(5) === identifier.toString()) {
            elementList.push(value[0])
          }
        })
      }
    } else {
      const items = [];
      this.subCategoriesStatusList.map((item) => {
        if (item.identifier.charAt(0) == identifier) {
          items.push(item)
        }
      })
      if (!items[0]) {
        return;
      }

      const elements = this.$refs['menu_' + items[0].identifier];
      if (typeof elements === 'object') {
        elementList.push(Object.values(elements).map(item => [item])[0][0])
      }
    }

    if (!elementList) {
      return;
    }
    const menuFirst = elementList[0] as HTMLElement;
    this.menuTop = menuFirst ? menuFirst.offsetTop : 0;
    window.scrollTo({
      top: this.menuTop,
      behavior: "smooth"
    });
  }

  private async _scrollListener() {
    this.pageYOffset = Math.round(window.pageYOffset);
    this.subCategoriesStatusList.map(async (item) => {
      if (this.$refs['menu_' + item.identifier] === undefined) {
        return;
      }
      const subCategoryTop = (this.$refs['menu_' + item.identifier][0] as HTMLElement).offsetTop;

      if (this.pageYOffset >= (subCategoryTop - this.MARGIN_CSS_DEFAULT)) {
        this.updateStatusParams(item.identifier);
        this.setOnSubCategorySidebar(item.identifier);
      }
    });

  }

  private async updateStatusParams(identifier, isCategory = false) {
    if (this.isOnStatusForCategory !== identifier) {
      this.isOnStatusForCategory = identifier;

      if (isCategory) {
        const identifierSub = await categoryApi.getFirstSubCategoryByIdentifier(identifier, this.subCategoriesStatusList)
        if (! identifierSub) {
          this.isOnStatusForSubCategory = identifierSub
        }
      }
    }

    if (!isCategory) {
      this.isOnStatusForCategory = identifier.charAt(0);
    }
  }

  private setOnSubCategorySidebar(identifier) {
    this.isOnStatusForSubCategory = identifier;
    (this.$refs['subCategory_' + identifier][0] as HTMLElement).scrollIntoView();
  }

  public openMenuDetail(menu, isEdit = false) {
    if (this.getNameLabel(menu) === "not-aycd") {
      this.aycdFlag = true;
      this.menuTmp = menu;
    } else if (this.getNameLabel(menu) === "menu_detail" || isEdit === true) {
      this.detailModal(menu, isEdit);
    }
  }

  public detailModal(menu, isEdit) {
    this.aycdFlag = false;
    (this.$refs.qDetailModal as QDetailModal).show(menu, isEdit);
  }

  public getNameLabel(menu) {
    if (!menu.allYouCanEat) {
      return "not-aycd";
    } else {
      return "menu_detail"
    }
  }

  public isShowRecommended(value) {
    return !(value === "" || value === "0")
  }
}
